import K from "../../../../@babel/runtime/helpers/esm/extends2.mjs";
import c from "../../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import Q from "../../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import U from "../../../../classnames/index2.mjs";
import Z from "../../../../rc-motion/es/CSSMotion.mjs";
import "../../../../rc-motion/es/CSSMotionList.mjs";
import * as o from "react";
import $ from "../../../../rc-resize-observer/es/index.mjs";
import ee from "../../../../rc-util/es/hooks/useLayoutEffect.mjs";
import { composeRef as oe } from "../../../../rc-util/es/ref.mjs";
import re from "./Arrow.mjs";
import te from "./Mask.mjs";
import ne from "./PopupContent.mjs";
var ie = /* @__PURE__ */ o.forwardRef(function(e, b) {
  var u = e.popup, k = e.className, l = e.prefixCls, P = e.style, d = e.target, N = e.onVisibleChanged, r = e.open, z = e.keepDom, M = e.onClick, R = e.mask, E = e.arrow, h = e.arrowPos, D = e.align, p = e.motion, L = e.maskMotion, x = e.forceRender, n = e.getPopupContainer, V = e.autoDestroy, A = e.portal, C = e.zIndex, H = e.onMouseEnter, I = e.onMouseLeave, S = e.ready, W = e.offsetX, O = e.offsetY, X = e.onAlign, w = e.onPrepare, i = e.stretch, s = e.targetWidth, f = e.targetHeight, Y = typeof u == "function" ? u() : u, _ = r || z, v = (n == null ? void 0 : n.length) > 0, j = o.useState(!n || !v), y = Q(j, 2), g = y[0], q = y[1];
  if (ee(function() {
    !g && v && d && q(!0);
  }, [g, v, d]), !g)
    return null;
  var F = S || !r ? {
    left: W,
    top: O
  } : {
    left: "-1000vw",
    top: "-1000vh"
  }, t = {};
  return i && (i.includes("height") && f ? t.height = f : i.includes("minHeight") && f && (t.minHeight = f), i.includes("width") && s ? t.width = s : i.includes("minWidth") && s && (t.minWidth = s)), r || (t.pointerEvents = "none"), /* @__PURE__ */ o.createElement(A, {
    open: x || _,
    getContainer: n && function() {
      return n(d);
    },
    autoDestroy: V
  }, /* @__PURE__ */ o.createElement(te, {
    prefixCls: l,
    open: r,
    zIndex: C,
    mask: R,
    motion: L
  }), /* @__PURE__ */ o.createElement($, {
    onResize: X,
    disabled: !r
  }, function(G) {
    return /* @__PURE__ */ o.createElement(Z, K({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: x,
      leavedClassName: "".concat(l, "-hidden")
    }, p, {
      onAppearPrepare: w,
      onEnterPrepare: w,
      visible: r,
      onVisibleChanged: function(a) {
        var m;
        p == null || (m = p.onVisibleChanged) === null || m === void 0 || m.call(p, a), N(a);
      }
    }), function(a, m) {
      var T = a.className, B = a.style, J = U(l, T, k);
      return /* @__PURE__ */ o.createElement("div", {
        ref: oe(G, b, m),
        className: J,
        style: c(c(c(c({
          "--arrow-x": "".concat(h.x || 0, "px"),
          "--arrow-y": "".concat(h.y || 0, "px")
        }, F), t), B), {}, {
          boxSizing: "border-box",
          zIndex: C
        }, P),
        onMouseEnter: H,
        onMouseLeave: I,
        onClick: M
      }, E && /* @__PURE__ */ o.createElement(re, {
        prefixCls: l,
        arrow: E,
        arrowPos: h,
        align: D
      }), /* @__PURE__ */ o.createElement(ne, {
        cache: !r
      }, Y));
    });
  }));
});
process.env.NODE_ENV !== "production" && (ie.displayName = "Popup");
export {
  ie as default
};
//# sourceMappingURL=index.mjs.map
